import { useEffect, useState, useRef } from 'react'
import { Modal, message, Button } from 'antd'
import { CloseOutlined, } from '@ant-design/icons';
import style from './index.module.scss'
import * as apis from '../../api/networkDisk'
import useStore from '../../store/useStore'
import { deepCopy, getImgUrlById } from '../../util';
import { StorageModule } from "../../modules/storage";
import TaskTagPop from '../../components/memos/taskTagPop';
import MDEditor from '@uiw/react-md-editor';
import "vditor/dist/index.css";
import Vditor from "vditor";
import ModelScreen from './modelScreen';

interface Props {
    visible?: any
    onClose?: () => void;
    onRefresh?: () => void;
    onClick?: (i: any) => void;
    data?: any;
    saveNode?: (i: any, txt: any,) => void;

}
interface State {
    txtStr: any
}
const MarkDownPop = (props: Props) => {

    const { store, dispatch } = useStore();
    const [isAdd, setIsAdd] = useState<boolean>(false);
    const [operationName, setOperationName] = useState<any>('');
    const [markDown, setMarkDown] = useState<any>('');
    const [vd, setVd] = useState<Vditor | any>();
    const [state, setState] = useState<State>({
        txtStr: ''
    })
    let vditor: any
    useEffect(() => {
        if (store.markDownVisible) {
            console.log('store.myEditMemo', store.myEditMemo)
            state.txtStr = store.myEditMemo.data.content

            setState(state)
            setMarkDown(store.myEditMemo.data.content)
            vditor = new Vditor("vditor", {
                mode: 'wysiwyg',
                cdn: "https://static.move2newidea.com/vditor/3.9.7",
                after: () => {
                    console.log('store.myEditMemo', store.myEditMemo)
                    let _str = store.myEditMemo.data.content || ''
                    // 图片格式切换为markdown格式：默认显示memo.content的内容，并将图片的链接以markdown链接格式加入memo.content(作为最后一行)，如果点击确认时仍然是选择markdown格式，则保存数据的同时修改memo的格式标签。
                    // 图片标注格式切换为markdown格式：默认显示memo.content的内容，并将图片的链接以markdown链接格式追加到memo.content中，在其后以markdown序号列表语法追加标注文本内容(保持序号一致)，如果点击确认时仍然是选择markdown格式，则保存数据的同时修改memo的格式标签并删除标注内容。
                    if (store.myEditMemo?.data?.hasOwnProperty('tagMetas')) {
                        store.myEditMemo.data?.tagMetas.map((i: any) => {
                            if (i.mimeType == "image/*") {
                                if (i.instance.imagePath) {
                                    _str = _str + `\n [${getImgUrlById(i.instance.imagePath)}](${getImgUrlById(i.instance.imagePath)})`
                                }
                            }
                            if (i.mimeType == "image/m2ni-img-notas") {
                                if (i.instance.imagePath) {
                                    _str = _str + `\n [${getImgUrlById(i.instance.imagePath)}](${getImgUrlById(i.instance.imagePath)})`
                                }
                                if (i.instance.annotation.length > 0) {
                                    i.instance.annotation.map((j: any, jdx: any) => {
                                        _str = _str + `\n ${jdx + 1}. ${j.description}`
                                    })
                                }
                            }
                        })
                    }
                    vditor.setValue(_str);
                    console.log('输入', vditor.getValue())
                    setMarkDown(vditor.getValue())
                    setVd(vditor.getValue())

                },
                input: (value) => {
                    console.log('value', value, store.myEditMemo)
                    setMarkDown(value)
                    setVd(value)
                    // dispatch({
                    //     type: 'SET_MYEDITMEMO',
                    //     data: { ...store.myEditMemo, content: value, data: { ...store.myEditMemo.data, content: value } }
                    // });
                },
            });
        } else {
            // vditor&&vditor.clearCache()
            // vditor&&vditor.destroy()
            setMarkDown('')
        }
    }, [store.markDownVisible])
    useEffect(() => {
        console.log('useEffect-markDown', markDown)
    }, [markDown])
    useEffect(() => {

    }, [])
    /**
    * 新建/修改markDown内容
    * @returns 
    */
    const putMarkDown = async () => {
        try {
            let memo: any = store.myEditMemo
            console.log(typeof markDown, markDown, vd)
            let res: any = await apis.putMemoNotation(memo.data.id, 'MarkdownTag', { content: markDown })
            console.log(typeof markDown, markDown)
            setMarkDown("")
            if (res.ok) {

                dispatch({
                    type: 'SET_MYEDITMEMO',
                    data: { ...store.myEditMemo, data: { ...store.myEditMemo.data, content: res.data.instance.content }, label: res.data.instance.content }
                });
                dispatch({
                    type: 'SET_MARKDOWNVISIBLE',
                    data: false
                });
                dispatch({
                    type: 'SET_CALENDARLABLE',
                    data: { ...res.data, content: res.data.instance.content }
                });
                // props.onRefresh && props.onRefresh()
                props.onClose && props.onClose()
            } else {

            }
        } catch (e) {
            console.log(typeof markDown, JSON.stringify(markDown))
            console.log('error', e)
        }
    }
    return (
        <>
            <div className='mb-10' data-flex='main:justify cross:center'>
                <ModelScreen name={
                    <div>markdown格式</div>
                } />

                <Button className='btn_dark btn mr-30' key='btn' onClick={() => {
                    console.log('markDown确认', store.memoOperation.isAdd)
                    if (store.memoOperation.isAdd) {
                        dispatch({
                            type: 'SET_MYEDITMEMO',
                            data: { ...store.myEditMemo, content: markDown, data: { ...store.myEditMemo.data, content: markDown } }
                        });
                        props.saveNode && props.saveNode('text/markdown', markDown)
                        props.onClose && props.onClose()
                    } else {
                        putMarkDown()
                    }
                }}>确认</Button></div>
            <div className='modalPreview'>
                <div id="vditor" className="vditor" />
            </div>
            {/* <Button className='btn_dark btn' key='btn' onClick={() => {
                    putMarkDown()
                }}>确认</Button> */}
            {/* <MDEditor
                    className={'markDown'}
                    value={markDown}
                    onChange={(e) => {
                        console.log(markDown, e)
                        state.txtStr = e
                        setState(state)
                        setMarkDown(e)
                    }}
                    // preview='preview'
                    height={500}
                /> */}
            {/* <MDEditor.Markdown source={cNode.current?.data?.label} /> */}

        </>
    )
}

export default MarkDownPop